import { Card, Stack, Divider, Box, Typography } from "@mui/material";
import { RedisStatus } from "./RedisStatus";
import { ServerDetails } from "./ServerDetails";

export const ServerStatusCard = ({ tenantId }: { tenantId: number }) => {
  return (
    <Card variant="outlined">
      <Stack
        sx={{
          padding: 2,
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5">Automation Server Status</Typography>
        </Box>
        <ServerDetails tenantId={tenantId} />
        <Divider />
        <RedisStatus tenantId={tenantId} />
      </Stack>
    </Card>
  );
};
